import { useEffect, useState } from "react";
import { AdminService } from "../../../core/services/AdminService";
import { PadreMenu } from "./PadreMenu";
import { Link, useNavigate } from "react-router-dom";
import { useDashboardStore } from "../../pages/hooks/useDashboardStore";
import { toast } from "react-toastify";
import { FileService } from "../../../core/services/FileService";
import { Modal } from "../Component/Modal";
import { _AbstractAccount, _single } from "../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { encryptData } from "../../../utils/helpers";


export const MenuModulo = () => {
  const adminService = new AdminService();
  const { setLoading } = useDashboardStore();
  const fileService = new FileService();
  const [menu, setMenu] = useState<any>([]);
  const [idRol, setIDRol] = useState(0);
  const [rolName, setRolName] = useState("");
  const [account, setAccount] = useState<any>({});
  const [roles, setListaRoles] = useState<any>([]);
  const [image, setImage] = useState<string>(null);



  const navigate = useNavigate();

  useEffect(() => {

    let acc = _single.getAccount() || {};

    if (acc.IDAccount) {
      setAccount(acc);

    }
    else {
      logout();
    }

  }, []);

  useEffect(() => {
    if (account.IDAccount) {
      _single.getIndexedDBItem("IDMenu_" + account.IDAccount).then((resp) => {
        console.log("StoreMenu", resp);
        if (resp) {
          getAccountRoleByAccount(parseInt(resp));
        } else {
          getAccountRoleByAccount();
        }
      });
    }
    if (account.Photo) {
      setImage(fileService.getUrlFile("photos", account.Photo));
    }
  }, [account])


  useEffect(() => {
    getUserMenu();
    _single.setIndexedDBItem("IDMenu_" + account.IDAccount, idRol);
    roles.forEach((rol: any) => {
      if (rol.DataBeanProperties.IDRole === idRol) {
        setRolName(rol.DataBeanProperties.RoleName);
        setOffice(rol.DataBeanProperties);
      }
    });
  }, [idRol]);

  const getAccountRoleByAccount = (idrol?: number) => {

    setLoading(true);
    let id: number = account.IDAccount;
    adminService.getAccountRoleByAccount(id, 0).subscribe((resp: any) => {
      if (resp.DataBeanProperties.ObjectValue) {
        let rol = resp.DataBeanProperties.ObjectValue;

        if (idrol) {
          setIDRol(idrol);
        }
        else if (rol.length > 0) {
          setIDRol(rol[0].DataBeanProperties.IDRole);
        }
        setListaRoles(resp.DataBeanProperties.ObjectValue);
      }
      setLoading(false);

    });
  };


  const getUserMenu = () => {
    let id: number = account.IDAccount;
    if (idRol > 0) {
      _single.spinner(true);
      adminService.getUserMenuRolesTypes(id, idRol, 0).subscribe(
        (resp: any) => {
          if (resp.DataBeanProperties.ErrorMessage) {

            toast.error("Token de acceso invalido ");
          }
          else if (resp.DataBeanProperties.ObjectValue) {
            let m = resp.DataBeanProperties.ObjectValue;
            let permisos: any = [];
            m.forEach((item: any) => {
              if (item.DataBeanProperties.Hijos) {
                item.DataBeanProperties.Hijos.forEach((hijo: any) => {
                  permisos.push(hijo);
                });
              }
            });
            setMenu(resp.DataBeanProperties.ObjectValue);
            _single.setPermision(permisos);
            _single.spinner(false);
          }
        }
      );
    };
  }
  const setOffice = (office: any) => {
    _single.setOffice({
      IDOffice: office.IDOffice,
      OfficeName: office.OfficeName,
      IDAccount: office.IDAccount,
      AccountName: office.AccountName,
      IDRole: office.IDRole,
      RoleName: office.RoleName,
    });
  }

  const logout = () => {
    _single.closeSesion();
    navigate("/login");
  };

  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [password, setPassword] = useState<string>("");
  const [password2, setPassword2] = useState<string>("");
  const [modal, setModal] = useState<any>({ name: "Actualizar Contraseña", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-md", });

  const [passwordValidation, setPasswordValidation] = useState({
    minLength: false,
    upperCase: false,
    lowerCase: false,
    number: false,
    specialChar: false,
    passwordsMatch: false,
    allValid: false
  });

  useEffect(() => {
    const validations = {
      minLength: password.length >= 8,
      upperCase: /[A-Z]/.test(password),
      lowerCase: /[a-z]/.test(password),
      number: /[0-9]/.test(password),
      specialChar: /[^A-Za-z0-9]/.test(password),
      passwordsMatch: password === password2
    };

    setPasswordValidation({
      ...validations,
      allValid: Object.values(validations).every(v => v === true)
    });
  }, [password, password2]);

  const { instance } = useDataBean(_AbstractAccount);

  const updatePassword = () => {
    if (!passwordValidation.allValid) {
      toast.error("La contraseña no cumple con los requisitos")
    } else {
      instance.activateUserAccountLocal(_single.getAccountID(), encryptData(_single.getSessionItem("userName")), encryptData(password)).then(
        (resp) => {
          toast.success("Contraseña actualizada correctamente")
          setModal({ ...modal, view: false });
          setPassword("");
        }
      ).catch(
        (err) => {
          toast.error("Error al actualizar la contraseña")
        }
      )
    }
  }

  return (
    <>
      <div className="containermenu pl-2 sider" style={{ width: "100%", maxWidth: "100%" }}>
        <div className="dropdown header-item" style={{ marginTop: _single.getIsMovil() ? "48px" : "0" }}>
          <button
            type="button"
            className=" btn_user"
            id="page-header-user-dropdown"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span className="d-flex align-items-center">
              <img
                className="rounded-circle header-profile-user"
                src={image ?? "assets/images/core/avatar.png"}
                alt="Header Avatar"
              />
              <span className="text-start d-flex flex-column mx-2" style={{ whiteSpace: 'nowrap', overflow: "hidden" }}>
                <span
                  style={{ color: "white", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}
                  className="d-xl-inline-block ms-1 fw-medium user-name-text"
                >
                  {account.EntityName}
                </span>
                <span style={{ color: "rgba(255,255,255,0.9)" }} className="d-xl-block ms-1 fs-12 text-muted user-name-sub-text">
                  {account.eMail}
                </span>
              </span>
            </span>
          </button>
          <div className="dropdown-menu dropdown-menu-end">
            <h6 className="dropdown-header">Tu cuenta</h6>

            <Link key={100} className="dropdown-item" to="/app/admin/perfil">
              <i className="mdi mdi-account-circle text-muted fs-16 align-middle me-1"></i>
              <span className="align-middle">Perfil</span>
            </Link>
            <Link key={101} className="dropdown-item" to="/app/admin/bandeja-mensajes">
              <i className="mdi mdi-message-text-outline text-muted fs-16 align-middle me-1"></i>{" "}
              <span className="align-middle">Mensajes</span>
            </Link>
            <Link key={102} className="dropdown-item" to="/app/admin/dashBoard">
              <i className="mdi mdi-calendar-check-outline text-muted fs-16 align-middle me-1"></i>{" "}
              <span className="align-middle">Dashboard</span>
            </Link>
            {_single.getLoginType() == "user/password" ?
              <Link key={103} className="dropdown-item" to="/app/admin/perfil" onClick={() => { setModal({ ...modal, view: true }) }} >
                <i className="mdi mdi-shield-lock-open-outline text-muted fs-16 align-middle me-1"></i>{" "}
                <span className="align-middle">Cambiar Contraseña</span>
              </Link> :
              (null)
            }
            <Link key={104} className="dropdown-item" to="/" onClick={logout}>
              <i className="mdi mdi-logout text-muted fs-16 align-middle me-1"></i>{" "}
              <span className="align-middle" data-key="t-logout">
                Salir
              </span>
            </Link>
          </div>
        </div>

        {roles.length > 1 && (
          <div className="btn-group mb-4">
            <button
              style={{ borderColor: "#fb8e00" }}
              className="btn btn-outline-warning dropdown-toggle colorad"
              type="button"
              id="droprole"
              data-bs-toggle="dropdown"
            >
              {rolName}
            </button>
            <ul className="dropdown-menu w-[100%]" aria-labelledby="droprole">
              {roles.map((item: any, index: number) => (
                <li key={index}>
                  <span
                    className="dropdown-item cursor"
                    onClick={() => {
                      setIDRol(item.DataBeanProperties.IDRole);

                    }}
                  >
                    <strong>
                      {item.DataBeanProperties.RoleName}
                      <br /><small>{item.DataBeanProperties.OfficeName ? "(" + item.DataBeanProperties.OfficeName + ")" : ""}</small>

                    </strong>
                  </span>
                </li>
              ))}
            </ul>
          </div>
        )}

        {menu.map((elemento: any, index: number) => (

          <div key={index}>

            {elemento.DataBeanProperties.Hijos.length > 0 && (
              <ul

                className="nav nav-sm flex-column"
                style={{ color: "white" }}
              >
                <PadreMenu key={index} DataBeanProperties={elemento.DataBeanProperties}></PadreMenu>
              </ul>
            )}
          </div>


        ))}
      </div>

      <Modal modal={modal} updateModal={setModal} eventModal={() => { updatePassword() }} >
        <div className="row">
          <div className="col-md-12 ">
            <label>Nueva Contraseña</label>
            <div className="input-group">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                placeholder="Ingrese su nueva contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                onCopy={(e) => { e.preventDefault(); toast.error("No se puede copiar el texto") }}
                onPaste={(e) => { e.preventDefault(); toast.error("No se puede pegar el texto") }}
                onCut={(e) => { e.preventDefault(); toast.error("No se puede cortar el texto") }}
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setShowPassword(!showPassword)}
                onCopy={(e) => { e.preventDefault(); toast.error("No se puede copiar el texto") }}
                onPaste={(e) => { e.preventDefault(); toast.error("No se puede pegar el texto") }}
                onCut={(e) => { e.preventDefault(); toast.error("No se puede cortar el texto") }}
              >
                {showPassword ? "Ocultar" : "Ver"}
              </button>
            </div>
          </div>

          <div className="col-md-12">
            <label>Confirmar Contraseña</label>
            <div className="input-group">
              <input
                type={showPassword2 ? "text" : "password"}
                className="form-control"
                placeholder="Confirme su nueva contraseña"
                value={password2}
                onChange={(e) => setPassword2(e.target.value)}
              />
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => setShowPassword2(!showPassword2)}
              >
                {showPassword2 ? "Ocultar" : "Ver"}
              </button>
            </div>
          </div>

          <div className="mt-3 text-start">
            {/* <p><strong>Requisitos de Contraseña:</strong></p> */}
            <ul className="list-unstyled small">
              <li style={{ color: passwordValidation.minLength ? "green" : "red" }}>
                {passwordValidation.minLength ? "✔️" : "❌"} Mínimo 8 caracteres
              </li>
              <li style={{ color: passwordValidation.upperCase ? "green" : "red" }}>
                {passwordValidation.upperCase ? "✔️" : "❌"} Al menos una letra mayúscula
              </li>
              <li style={{ color: passwordValidation.lowerCase ? "green" : "red" }}>
                {passwordValidation.lowerCase ? "✔️" : "❌"} Al menos una letra minúscula
              </li>
              <li style={{ color: passwordValidation.number ? "green" : "red" }}>
                {passwordValidation.number ? "✔️" : "❌"} Al menos un número
              </li>
              <li style={{ color: passwordValidation.specialChar ? "green" : "red" }}>
                {passwordValidation.specialChar ? "✔️" : "❌"} Al menos un carácter especial
              </li>
              <li style={{ color: passwordValidation.passwordsMatch ? "green" : "red" }}>
                {passwordValidation.passwordsMatch ? "✔️" : "❌"} Las contraseñas coinciden
              </li>
            </ul>
          </div>
        </div>
      </Modal>
    </>
  );
};
